import { render, staticRenderFns } from "./Sheet.vue?vue&type=template&id=5e510a2c"
import script from "./Sheet.vue?vue&type=script&lang=js"
export * from "./Sheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports